import * as angular from 'angular';
import { EventEmailDefinition } from '../../models';
import { ITranslatedLoggerService, IRequestService } from '../';

export interface IHtmlMailService {
    send(mail: EventEmailDefinition): angular.IPromise<void>;
    trigger(mailGuid: string, groupGuid: string, beginDate: string, endDate: string): angular.IPromise<void>;
}

export class HtmlMailService implements IHtmlMailService {
    static serviceId = 'htmlMailService';
    static $inject = ['requestService', 'translatedLoggerService'];

    private _controllerUrl = 'htmlMail/';

    constructor(
        private _requestService: IRequestService,
        private _loggerService: ITranslatedLoggerService
    ) {
    }

    send(mail: EventEmailDefinition): angular.IPromise<void> {
        return this._requestService
            .postAtV1(`${this._controllerUrl}/send`, mail)
            .then(() => this._loggerService.logSuccess('E-mail successfully sent', true))
            .catch(() => this._loggerService.logError('Failed to send e-mail', true));
    }

    trigger(mailGuid: string, groupGuid: string, beginDate: string, endDate: string): angular.IPromise<void> {
        return this._requestService
            .postAtV1(`${this._controllerUrl}/trigger`, { mailGuid, groupGuid, beginDate, endDate })
            .then(() => this._loggerService.logSuccess('E-mail successfully sent'))
            .catch(reason => {
                this._loggerService.logError('Failed to send e-mail');
                this._loggerService.logError(reason);
            });
    }
}